import {
    createSimpleTableComponent,
    ISimpleTableItem,
    ISimpleTableProperties,
    SimpleTable,
} from '@vfde-brix/simple-table';

/**
 * Mount the simple table
 * @param container
 * @param data
 */
export const mountSimpleTable = (container, data): SimpleTable => {
    const items = [];
    const valueSpecials = {
        Nachhaltigkeit: getEcoLabel,
    };

    for (const [label, value] of Object.entries(data)) {
        const valueSpecial = valueSpecials[label.replace(' ', '-')];
        const item = valueSpecial ? valueSpecial(label, value) : {
            stdName: label,
            stdValue: value,
        };

        items.push(item);
    }

    const properties: ISimpleTableProperties<ISimpleTableItem> = {
        items,
        spacing: '0',
        hasBottomBorder: false,
        hasTopBorder: false,
        business: {},
    };

    return createSimpleTableComponent(container, properties);
};

const getEcoLabel = (label, value) => {
    const {link, text} = (window as any).additionalPageOptions.ecoLabel;

    return {
        stdName: label,
        stdValue: `${value} <a href=${link} class="brix-text-link-style" target="_blank" rel="noopener noreferrer">${text}</a>`,
    };
};
